export default __webpack_public_path__ + "static/media/LineosoftArticleAdd-min.585c866e.PNG";